module.exports = __webpack_public_path__ + "img/inter_throw_screen.572e4db2.svg";